<template>
  <Addresses :bank-address="bankAddress" :main-address="mainAddress" />
</template>

<script>
// Libraries
import { mapActions, mapGetters } from 'vuex'
// Components
import Addresses from '@/reusable/addresses-tab/Addresses'

export default {
  components: {
    Addresses
  },

  provide() {
    return {
      updateProvider: this.updatePublisher
    }
  },

  computed: {
    ...mapGetters('publisher-show', ['mainAddress', 'bankAddress'])
  },

  methods: {
    ...mapActions('publisher-show', ['updatePublisher'])
  }
}
</script>
